/* ==========================================================================
   LBBL Premium — Global Foundation Script V2
   Loyalty Beyond Beauty LLC · Shopify Dawn
   Loaded with defer. Every module is guarded and fails gracefully.
   No external frameworks. No jQuery.
   ========================================================================== */
(function () {
  "use strict";

  var prefersReducedMotion = false;
  try {
    prefersReducedMotion = window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  } catch (e) { prefersReducedMotion = false; }

  function closest(el, selector) {
    return el && el.closest ? el.closest(selector) : null;
  }

  function triggerClickOnKey(ev, selector) {
    var target = closest(ev.target, selector);
    if (!target) return;
    if (ev.key === "Enter" || ev.key === " ") {
      ev.preventDefault();
      target.click();
    }
  }

  /* ---- Module 1: Scroll reveal ---------------------------------------- */
  function initReveal() {
    var els = document.querySelectorAll(".lbbl-reveal");
    if (!els.length) return;

    if (prefersReducedMotion || typeof IntersectionObserver === "undefined") {
      for (var i = 0; i < els.length; i++) els[i].classList.add("is-visible");
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          obs.unobserve(entry.target);
        }
      });
    }, { rootMargin: "0px 0px -10% 0px", threshold: 0.08 });

    for (var j = 0; j < els.length; j++) obs.observe(els[j]);
  }

  /* ---- Module 2: Sticky mobile CTA ------------------------------------ */
  function initStickyCta() {
    var bars = document.querySelectorAll("[data-lbbl-sticky-cta]");
    if (!bars.length) return;

    var path = ((window.location && window.location.pathname) || "").toLowerCase();
    if (path.indexOf("/cart") === 0 || path.indexOf("/checkout") === 0) return;

    function update() {
      var show = window.pageYOffset > 600;
      for (var i = 0; i < bars.length; i++) {
        bars[i].classList.toggle("is-visible", show);
      }
    }

    update();

    var ticking = false;
    window.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        update();
        ticking = false;
      });
    }, { passive: true });
  }

  /* ---- Module 3: Ask the Ritual Guide chips --------------------------- */
  function initChips() {
    document.addEventListener("click", function (ev) {
      var chip = closest(ev.target, "[data-lbbl-chip]");
      if (!chip) return;

      var group = closest(chip, "[data-lbbl-chip-group]");
      if (!group) return;

      var targetId = chip.getAttribute("data-lbbl-chip-target");
      var chips = group.querySelectorAll("[data-lbbl-chip]");
      var panels = group.querySelectorAll("[data-lbbl-chip-panel]");

      for (var i = 0; i < chips.length; i++) {
        chips[i].setAttribute("aria-pressed", chips[i] === chip ? "true" : "false");
      }
      for (var j = 0; j < panels.length; j++) {
        panels[j].hidden = (panels[j].id !== targetId);
      }
    });

    document.addEventListener("keydown", function (ev) {
      triggerClickOnKey(ev, "[data-lbbl-chip]");
    });
  }

  /* ---- Module 4: Copy My Ritual Plan ---------------------------------- */
  function initCopyPlan() {
    document.addEventListener("click", function (ev) {
      var btn = closest(ev.target, "[data-lbbl-copy-plan]");
      if (!btn) return;

      var srcId = btn.getAttribute("data-lbbl-copy-source");
      var src = srcId ? document.getElementById(srcId) : null;
      var text = src ? (src.innerText || src.textContent || "") : "";
      if (!text) return;

      var confirm = function () {
        var original = btn.getAttribute("data-lbbl-label-original") || btn.textContent;
        btn.setAttribute("data-lbbl-label-original", original);
        btn.textContent = btn.getAttribute("data-lbbl-label-copied") || "Copied";
        setTimeout(function () { btn.textContent = original; }, 2000);
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(confirm, function () { fallbackCopy(text, confirm); });
      } else {
        fallbackCopy(text, confirm);
      }
    });
  }

  function fallbackCopy(text, done) {
    try {
      var ta = document.createElement("textarea");
      ta.value = text;
      ta.setAttribute("readonly", "");
      ta.style.position = "absolute";
      ta.style.left = "-9999px";
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
      if (done) done();
    } catch (e) {}
  }

  /* ---- Module 5: Find Your Ritual quiz (data-driven) ------------------ */
  function initQuiz() {
    var quizzes = document.querySelectorAll("[data-lbbl-quiz]");
    for (var i = 0; i < quizzes.length; i++) setupQuiz(quizzes[i]);
  }

  function setupQuiz(root) {
    var steps = root.querySelectorAll("[data-lbbl-quiz-step]");
    if (!steps.length) return;

    var progressFill = root.querySelector("[data-lbbl-quiz-progress-fill]");
    var progressLabel = root.querySelector("[data-lbbl-quiz-progress-label]");
    var resultPanel = root.querySelector("[data-lbbl-quiz-result]");
    var scoreEl = root.querySelector("[data-lbbl-quiz-score]");
    var recommendationEl = root.querySelector("[data-lbbl-quiz-recommendation]");

    var current = 0;
    var total = steps.length;
    var answers = {};
    var labels = {};

    function render() {
      for (var i = 0; i < steps.length; i++) steps[i].hidden = (i !== current);
      if (resultPanel) resultPanel.hidden = true;
      var pct = Math.round(((current + 1) / total) * 100);
      if (progressFill) progressFill.style.width = pct + "%";
      if (progressLabel) progressLabel.textContent = "Step " + (current + 1) + " of " + total;
    }

    function computeScore() {
      var sum = 0;
      var count = 0;
      for (var key in answers) {
        if (Object.prototype.hasOwnProperty.call(answers, key)) {
          sum += answers[key];
          count++;
        }
      }
      var avg = count ? (sum / count) : 0;
      var score = 78 + Math.round(avg);
      if (score > 96) score = 96;
      if (score < 78) score = 78;
      return score;
    }

    function computeRecommendation() {
      var joined = Object.keys(labels).map(function (key) { return labels[key]; }).join(" ").toLowerCase();
      if (joined.indexOf("one product") > -1 || joined.indexOf("protective balm") > -1 || joined.indexOf("feet") > -1 || joined.indexOf("heels") > -1) {
        return "Golden Barrier Ritual™ or a focused balm step";
      }
      return "The Golden Barrier Ritual™";
    }

    function finish() {
      if (scoreEl) scoreEl.textContent = computeScore() + "%";
      if (recommendationEl) recommendationEl.textContent = computeRecommendation();
      for (var i = 0; i < steps.length; i++) steps[i].hidden = true;
      if (progressFill) progressFill.style.width = "100%";
      if (progressLabel) progressLabel.textContent = "Your Ritual Match Score";
      if (resultPanel) {
        resultPanel.hidden = false;
        root.dispatchEvent(new CustomEvent("lbbl:quiz:complete", { bubbles: true }));
        if (resultPanel.scrollIntoView) {
          resultPanel.scrollIntoView({ behavior: prefersReducedMotion ? "auto" : "smooth", block: "start" });
        }
      }
    }

    root.addEventListener("click", function (ev) {
      var opt = closest(ev.target, "[data-lbbl-quiz-option]");
      if (opt && root.contains(opt)) {
        var stepEl = closest(opt, "[data-lbbl-quiz-step]");
        var stepIndex = stepEl ? parseInt(stepEl.getAttribute("data-lbbl-quiz-step"), 10) : current;
        var weight = parseInt(opt.getAttribute("data-lbbl-quiz-weight"), 10);
        if (isNaN(weight)) weight = 12;
        answers["s" + stepIndex] = weight;
        labels["s" + stepIndex] = opt.getAttribute("data-lbbl-quiz-label") || opt.textContent || "";

        var siblings = stepEl ? stepEl.querySelectorAll("[data-lbbl-quiz-option]") : [];
        for (var i = 0; i < siblings.length; i++) {
          siblings[i].setAttribute("aria-pressed", siblings[i] === opt ? "true" : "false");
        }

        if (current < total - 1) {
          current++;
          render();
        } else {
          finish();
        }
        return;
      }

      var back = closest(ev.target, "[data-lbbl-quiz-back]");
      if (back && root.contains(back) && current > 0) {
        current--;
        render();
      }
    });

    root.addEventListener("keydown", function (ev) {
      triggerClickOnKey(ev, "[data-lbbl-quiz-option]");
      triggerClickOnKey(ev, "[data-lbbl-quiz-back]");
    });

    render();
  }

  function init() {
    try { initReveal(); } catch (e) {}
    try { initStickyCta(); } catch (e) {}
    try { initChips(); } catch (e) {}
    try { initCopyPlan(); } catch (e) {}
    try { initQuiz(); } catch (e) {}
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
